var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_722_6479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.332 20.5C10.332 14.9772 14.8092 10.5 20.332 10.5H30.332C35.8549 10.5 40.332 14.9772 40.332 20.5V40.5H20.332C14.8092 40.5 10.332 36.0228 10.332 30.5V20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1769 31.6166H20.4626C19.7162 31.6166 19.1055 31.0059 19.1055 30.2595V20.7595C19.1055 20.0131 19.7162 19.4023 20.4626 19.4023H23.1769C23.9233 19.4023 24.534 20.0131 24.534 20.7595V30.2595C24.534 31.0059 23.9233 31.6166 23.1769 31.6166ZM27.2483 31.6166H29.9626C30.709 31.6166 31.3198 31.0059 31.3198 30.2595V26.8666C31.3198 26.1202 30.709 25.5095 29.9626 25.5095H27.2483C26.5019 25.5095 25.8912 26.1202 25.8912 26.8666V30.2595C25.8912 31.0059 26.5019 31.6166 27.2483 31.6166ZM31.3198 22.7952V20.7595C31.3198 20.0131 30.709 19.4023 29.9626 19.4023H27.2483C26.5019 19.4023 25.8912 20.0131 25.8912 20.7595V22.7952C25.8912 23.5416 26.5019 24.1523 27.2483 24.1523H29.9626C30.709 24.1523 31.3198 23.5416 31.3198 22.7952Z",
    fill: "url(#paint0_linear_722_6479)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_722_6479",
    x: 0.332031,
    y: 0.5,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.589833 0 0 0 0 0.108333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_722_6479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_722_6479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_6479",
    x1: 19.1055,
    y1: 25.5095,
    x2: 31.3198,
    y2: 25.5095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF45"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHome);
export default __webpack_public_path__ + "static/media/ico-home.85aaa6a93040542abc8ac1e9b45e2113.svg";
export { ForwardRef as ReactComponent };